import clsx from "clsx";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import DynamicFormField from "~/components/Forms/DealerPassportForm2/UI/DynamicFormField";
import { useTranslation } from "react-i18next";
import s from "./Base.less";
import FileLoader from "~/components/FileLoader";
import Accordion from "~/components/Forms/DealerPassportForm2/UI/Accordion";
import IconEdit from "~/components/Icons/icon-default";
import Button from "~/shared/ui/Fields/Button";
import Select from "~/shared/ui/Fields/Select";
import { newSelectStyles } from "../options";
import { EDITABLE_BASE_FIELDS } from "~/components/Forms/DealerPassportForm2/Base/options";
import { yupResolver } from "@hookform/resolvers/yup";
import { formResolver } from "~/components/Forms/DealerPassportForm2/Base/lib/config/resolver";
import { usePermissions } from "~/shared/context/PermissionContext";

const Base = ({
  idArchive,
  dealersForSelect,
  dataDealer,
  onSubmit,
  dealerFields,
  dealerFieldsDop,
  dealerDopBir,
  defaultValue,
  allDisabled,
}) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  let isRu = localStorage.getItem("language") === "ru";
  const method = useForm({
    defaultValues: defaultValue,
    resolver: yupResolver(formResolver(t)),
  });

  const photoDealerCenterIdWatch = method.watch("photoDealerCenterId");

  const isPhotoChanged =
    photoDealerCenterIdWatch !== defaultValue?.photoDealerCenterId;
  const canSubmitByPhoto =
    hasPermission("dealer.updateBase.photo") && isPhotoChanged;

  useEffect(() => {
    method.reset(defaultValue);
  }, [defaultValue]);

  const deleteFileByName = (fileField: string, idField: string) => {
    const formData = method.getValues();
    const updatedData = { ...formData, [fileField]: null, [idField]: null };
    method.reset(updatedData);
    method.register(idField);
  };

  console.log('dealerFields',dealerFields);

  return (
    <div>
      <FormProvider {...method}>
        <form
          onSubmit={method.handleSubmit(onSubmit)}
          className={clsx("dynamic-form")}
        >
          <div className={s.wrapper}>
            <IconEdit />
            <div
              className={clsx(s.wrapperDealerImg, {
                [s.imgActive]: !!photoDealerCenterIdWatch,
              })}
            >
              {dataDealer && (
                <FileLoader
                  name={"photoDealerCenterId"}
                  withIMG
                  isNoneUpload={idArchive}
                  isNewStyle
                  deleteFile={() =>
                    deleteFileByName("PhotoDealerCenter", "photoDealerCenterId")
                  }
                  download={dataDealer.PhotoDealerCenter}
                  control={method.control}
                  setValue={method.setValue}
                  disabled={!hasPermission("dealer.updateBase.photo")}
                />
              )}
            </div>

            <div className={s.wrapperRight}>
              <div className={s.wrapperBase}>
                <div className={s.title}>Основная информация</div>
                {dataDealer &&
                  dealerFields.map((field, index) =>
                    ["successorId", "headCompanyId"].includes(field.name) ? (
                      <Select
                        key={`${field.name}-${index}`}
                        name={field.name}
                        control={method.control}
                        label={t(`dealers.${field.name}`)}
                        disabled={true || allDisabled}
                        optionObjects={[
                          {
                            value:
                              field.name === "successorId" ? "-1" : undefined,
                            label: t("violationsTable.defaultFilterVal"),
                          },
                          ...dealersForSelect["dealersForSelect"],
                        ]}
                        newStyle
                        error={method.errors[field.name]?.value?.message}
                        onScrollBottom={
                          dealersForSelect["introspectionHandler"]
                        }
                        getSearchText={dealersForSelect["searchDealer"]}
                        customClassName={s.selectEdit}
                        newCustomClassNames={newSelectStyles}
                      />
                    ) : (
                      <DynamicFormField
                        key={field.name}
                        {...field}
                        disabled={
                          !EDITABLE_BASE_FIELDS.includes(field.name) ||
                          allDisabled
                        }
                      />
                    )
                  )}
              </div>
              <div>
                <Accordion>
                  <div className={s.itemFirst}>
                    {dataDealer &&
                      dealerFieldsDop.map((field) => (
                        <DynamicFormField
                          key={field.name}
                          {...field}
                          disabled={
                            field.type === "boolean" ? allDisabled : true
                          }
                        />
                      ))}
                  </div>
                  <div className={s.itemFirst}>
                    {dataDealer &&
                      dealerDopBir.map((field) => (
                        <DynamicFormField
                          key={field.name}
                          {...field}
                          disabled={
                            field.name === "birCode" ? allDisabled : true
                          }
                        />
                      ))}
                  </div>
                </Accordion>
              </div>
              {(!allDisabled || canSubmitByPhoto) && (
                <Button
                  txtBtn={"Сохранить изменения"}
                  orange
                  isForm
                  customClassName={s.but}
                />
              )}
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default Base;
